import client from "../client";

export interface ResetPasswordRequest {
  password?: string;
  confirm_password?: string;
}

export default function API(request: ResetPasswordRequest) {
  return client
    .post(`auth/reset_password`, request)
    .then((response) => response.data)
    .then((json) => {
      return json;
    });
}
